import { Category } from '../types/Category';

export const categories: Category = {
  food: { title: 'Food', color: 'blue', expense: true },
  rent: { title: 'Rent', color: 'brown', expense: true },
  salary: { title: 'Salary', color: 'green', expense: false },
};